import { ChangeDetectorRef, Directive, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Logger } from '@df/core/service/logger';
import { Status } from '@df/core/status';
import { Xnotif } from '@df/module-xnotif/xnotif.interfaces';
import { XnotifService } from '@df/module-xnotif/xnotif.service';
import { Subscription } from 'rxjs';

@Directive()
// tslint:disable-next-line: directive-class-suffix
export class XnotifFormComponentDef implements OnInit, OnChanges, OnDestroy {
    /**
     * Data model
     */
    data!: Omit<Xnotif.IData, 'product_id'>;

    /**
     * Product model to notify about
     */
    @Input({
        required: true
    })
    model!: Product<IProductDataV3>;

    /**
     * If success status is now
     */
    isSuccess = false;

    /**
     * Form
     * important: you need to put #form="ngForm" on form element in template
     */
    @ViewChild('form', { static: false })
    public form?: NgForm;

    /**
     * Status model
     */
    readonly status = new Status();

    /**
     * Change subscriptions
     */
    protected subscription = new Subscription();

    /**
     * Class contrucotr
     */
    constructor(
        private xnotifService: XnotifService,
        private logger: Logger,
        private ref: ChangeDetectorRef
    ) {
        this.reset();
    }

    ngOnInit(): void {
        this.subscription.add(this.status.subscribe(() => this.detectChanges()));
    }

    /**
     * Reset isSuccess on changes
     */
    ngOnChanges() {
        this.isSuccess = false;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    /**
     * Submission
     */
    submit() {
        if (!this.model) {
            this.logger.error('No model linked to xnotif form');
            this.status.error = 'Unexpected error';
            return;
        }
        if (!this.form) {
            this.logger.error('No form linked to xnotif form');
            this.status.error = 'Unexpected error';
            return;
        } else {
            const data: Xnotif.IData = { ...this.data, product_id: this.model.id };
            this.xnotifService.submit(this.form, this.status, data, () => this.onSuccess(data));
        }
        this.detectChanges();
    }

    /**
     * Succcess callback
     */
    protected onSuccess(data: Xnotif.IData) {
        this.reset();
        this.isSuccess = true;
        this.detectChanges();
    }

    private reset() {
        this.data = {
            guest_email: '',
            newsletter: false,
            gdpr: false
        };
    }

    protected detectChanges() {
        this.ref.detectChanges();
    }
}
